// This file was automatically generated from uiwidget.NewMindreader.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.NewMindreader');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.NewMindreader.container = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="mr-dropdown el8ActionsMenuDialog"><div class="mr-dropdown-content el8MRContainer"><div class="mr-results-info el8MRInformText"></div>', (opt_data.hasActions && opt_data.actionsFirst) ? '<div class="mr-actions"></div>' : '', '<div class="mr-results"></div>', (opt_data.hasActions && ! opt_data.actionsFirst) ? '<div class="mr-actions ' + ((opt_data.fixedPos) ? 'el8MRFloatingActionContainer' : '') + '"></div>' : '', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.NewMindreader.resultsSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.title) ? '<p class="mr-title-' + soy.$$escapeHtml(opt_data.name) + ' mr-descriptionText mr-subheader el8MRHeader el8MRHeader' + (soy.$$escapeHtml(opt_data.name)? soy.$$escapeHtml(opt_data.name).capitalize() : '') + '">' + soy.$$escapeHtml(opt_data.title) + '</p>' : '', '<div class="mr-', soy.$$escapeHtml(opt_data.name), ' mr-subheader el8MRSection el8MRSection', (soy.$$escapeHtml(opt_data.name)? soy.$$escapeHtml(opt_data.name).capitalize() : ''), '"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.NewMindreader.item = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="mr-dropdown-item');
  var cList925 = opt_data.classes;
  var cListLen925 = cList925.length;
  for (var cIndex925 = 0; cIndex925 < cListLen925; cIndex925++) {
    var cData925 = cList925[cIndex925];
    output.append(' ', soy.$$escapeHtml(cData925));
  }
  output.append('" role="listitem" _mr_list="', soy.$$escapeHtml(opt_data.listName), '" _mr_index="', soy.$$escapeHtml(opt_data.index), '"></div>');
  if (!opt_sb) return output.toString();
};
